$(document).ready(function () {

// from http://jsfiddle.net/xuhP9/77/
// handles the carousel thumbnails
    $('[id^=carousel-selector]').click(function () {
        var id_selector = $(this).attr('id');
        var id = id_selector.substr(id_selector.length - 1);
        id = parseInt(id);
        var parent = $(this).closest('ul').data('carousel');
        $('#myCarousel' + parent).carousel(id);
        $('[id^=carousel-selector' + parent + '-]').removeClass('selected');
        $(this).addClass('selected');
    });

    // when the carousel slides, auto update
    $('.customCarousel').on('slid', function (e) {
        var cont = $(this).data('carousel');
        var id = $('#myCarousel' + cont + ' .item.active').data('slide-number');
        id = parseInt(id);
        $('[id^=carousel-selector' + cont + '-]').removeClass('selected');
        $('[id^=carousel-selector' + cont + '-' + id + ']').addClass('selected');

    });

});

